<template>
	<main>
		<div class="flex items-center justify-center bg-black text-white py-16">
			<div class="w-full flex flex-col items-center justify-center text-center">
				<h1 class="text-6xl font-black tracking-wider">China!</h1>
				<h2 class="text-3xl mt-4">Free Pastor Wang Yi</h2>
			</div>
		</div>
		<div class="w-full flex flex-col md:flex-row items-center md:items-start justify-center my-12">
	<!-- 		<div class="w-full max-w-xs">
				<h2 class="text-4xl tracking-wide mb-4 font-black">Articles</h2>
			</div> -->
			<div class="w-full md:w-2/3 px-4 max-w-4xl pr-8">
				<a
					href="https://www.paypal.com/donate?business=chinapersecution.org%40gmail.com&currency_code=USD"
					target="_blank"
					class="block w-full bg-red-600 hover:bg-red-700 text-white text-center font-bold py-4 px-6 rounded-lg mb-8 text-lg"
				>
					Donate to help us put these Billboards across America and Banners all over the internet
				</a>
				<h2 class="text-4xl tracking-wide mb-4 font-black">Videos</h2>
				<div v-for="{title, id} in videos" class="py-4 text-xl">
					<a target="_blank" class="hover:text-gray-600 flex flex-col">
						<div class="video-container">
							<iframe
								class="video-iframe"
								:src="`https://www.youtube.com/embed/${id}`"
								allowfullscreen
							></iframe>
						</div>
						<div class="text-center mt-4 mb-8">{{ title }}</div>
					</a>
				</div>
			</div>
			<div class="w-full md:w-1/3 px-4 md:border-l border-gray-600 md:pl-8">
				<h2 class="text-4xl tracking-wide font-black">News</h2>
				<div v-for="{title, link} in news" class="py-4 text-xl border-b border-gray-600">
					<a target="_blank" :href="link" class="hover:text-gray-600">{{ title }}</a>
				</div>
				<h2 class="text-4xl tracking-wide font-black mt-8">Articles</h2>
				<div v-for="{title, link} in articles" class="py-4 text-xl border-b border-gray-600">
					<a target="_blank" :href="link" class="hover:text-gray-600">{{ title }}</a>
				</div>
				<div class="w-full flex flex-col text-2xl mt-8">
					<div class="">Pastor Wang Yi has been in prison since December 9, 2018:</div>
					<div>
						<label id="years">00</label> Year,
						<label id="days">00</label> Days,
						<label id="hours">00</label>:
						<label id="minutes">00</label>:
						<label id="seconds">00</label></div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Swal from 'sweetalert2';

export default {
	data() {
		return {
			videos: [
				{
					title: 'Free Pastor Wang Yi',
					id: 'uGauMoyygGE'
				},
				{
					title: 'When to Resist, When to Submit',
					id: 'q5jauHt8YFE'
				},
				{
					title: 'Repentance - Paul Washer',
					id: '6mcpWQVgDDI'
				},
				{
					title: 'Jesus Christ came into the world to save sinners- (The Meaning of Christmas)  John MacArthur',
					id: 'tfHkDnWtpVY'
				},
				{
					title: 'The Gospel of Jesus Christ- Paul Washer',
					id: 'gy-XgK0VW9M'
				},
				{
					title: 'The Holiness of God- RC Sproul',
					id: 'SErpRpUeDAQ'
				},
				{
					title: 'Persecution in China- John MacArthur with Dr. Daniel Wang',
					id: '08CNJziEChs'
				},
				{
					title: 'The Role of Civil Authority - RC Sproul',
					id: 'Z1IYd58YhCk'
				},
				{
					title: 'Xi Jinping Must Repent',
					id: 'eWuv55YgKjY'
				},
				{
					title: '第十屆聖詩頌唱會 26 主為保障 A Mighty Fortress is Our God',
					id: 'd18GK6ArWnY'
				}
			],
			news: [
				{
					link: 'https://www.christianpost.com/news/china-trying-to-rewrite-the-bible-force-churches-sing-communist-anthems.html',
					title: 'China Plans To “Re-write” The Bible- Christian Post'
				},
				{
					link: 'https://www.crosswalk.com/headlines/contributors/michael-foust/china-bans-kids-from-attending-church-threatens-parents-who-break-law-watchdog.html',
					title: 'China Bans Children From Attending Church With Their Parents- ONN'
				},
				// {
				// 	link: 'https://www.state.gov/conviction-of-chinese-christian-pastor-wang-yi/',
				// 	title: 'U.S. State Department Demands Release Of Pastor Wang Yi'
				// },
				{
					link: 'https://time.com/5757591/wang-yi-prison-sentence-china-christianity/',
					title: 'Prison Sentence for Pastor Shows China Feels Threatened by Spread of Christianity- Time'
				},
				// {
				// 	link: 'https://www.christianpost.com/news/trump-admin-condemns-imprisonment-of-chinese-pastor-wang-yi-calls-for-his-release-we-are-alarmed.html',
				// 	title: 'Trump Administration Condemns Imprisonment Of Chinese Christian Pastor'
				// }
			],
			articles: [
				{
					link: 'https://www.facebook.com/prayforearlyrain/',
					title: 'Early Rain Christian Church Facebook Page'
				},
				{
					link: '/article',
					title: 'Letter Published After Pastor Wang Yi\'s Arrest'
				},
				{
					link: 'http://the-end-time.blogspot.com/2014/11/the-chinese-macarthur-study-bible-1000.html',
					title: 'MacArthur Study Bible Given To 1000 Chinese Pastors'
				}
			]
		}
	},
mounted() {
    var yearsLabel = document.getElementById("years");
    var daysLabel = document.getElementById("days");
    var hoursLabel = document.getElementById("hours");
    var minutesLabel = document.getElementById("minutes");
    var secondsLabel = document.getElementById("seconds");

    var startDate = new Date(2018, 11, 9, 15, 0, 0); // December 9, 2018, 3:00 PM
    setInterval(setTime, 1000);

    function setTime() {
        var now = new Date();
        var totalSeconds = Math.floor((now - startDate) / 1000);

        yearsLabel.innerHTML = parseInt(totalSeconds / (60*60*24*365));
        daysLabel.innerHTML = parseInt((totalSeconds % (60*60*24*365)) / (60*60*24));
        hoursLabel.innerHTML = parseInt((totalSeconds % (60*60*24)) / (60*60));
        minutesLabel.innerHTML = pad(parseInt((totalSeconds % (60*60)) / 60));
        secondsLabel.innerHTML = pad(totalSeconds % 60);
    }

    function pad(val) {
        return val.toString().padStart(2, "0");
    }
  }
};
</script>

<style>

</style>
